import {Html} from 'quickstart/components/content/Html'
import styled from 'quickstart/styled-components/system'
import {ComponentProps, ComponentPropsWithoutRef} from 'react'
import {logger} from 'tizra'

const LOG = logger('MetaValue/useRenderedValue')

export type UseRenderedValueProps = Partial<
  Omit<ComponentPropsWithoutRef<typeof Html>, 'html'>
> &
  ComponentProps<'span'> & {
    displayType: 'html' | 'text' | 'string'
    displayValue: string
  }

// This will handle the as prop, and drop props that don't apply.
const Span = styled.span``

export const useRenderedValue = (
  {displayType, displayValue, ...props}: UseRenderedValueProps,
  ref?: any,
) => {
  switch (displayType) {
    case 'html':
      return <Html variant="raw" {...props} html={displayValue} ref={ref} />
    case 'text':
      return (
        <Html
          {...props}
          style={{whiteSpace: 'pre-line', ...props.style}}
          ref={ref}
        >
          {displayValue}
        </Html>
      )
    // @ts-expect-error intentional fall through
    default: {
      const unreachable: never = displayType
      LOG.error('unreachable displayType', unreachable)
      // falls through (for eslint)
    }
    case 'string':
      return (
        <Span ref={ref} {...props}>
          {displayValue}
        </Span>
      )
  }
}
